import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import styled from 'styled-components';
import throttle from 'lodash.throttle';
import {theme} from '../lib/theme';
import {toggleTooltip} from '../lib/utils';

const StyledTooltip = styled.div`
  width: auto;
  max-width: calc(100% - 32px);
  border-radius: 0;
  background-color: #fff;
  display: inline-block;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  z-index: 9;
  padding: 4px 10px;
  text-align: left;
  box-shadow: 0 0 10px 0 rgba(51, 51, 51, .15);
  height: auto;
  cursor: default;
  -webkit-transition: opacity .2s linear, left .2s ease-in-out, top .2s ease-in-out;
  -moz-transition: opacity .2s linear, left .2s ease-in-out, top .2s ease-in-out;
  -o-transition: opacity .2s linear, left .2s ease-in-out, top .2s ease-in-out;
  transition: opacity .2s linear, left .2s ease-in-out, top .2s ease-in-out;
  &.active {
    opacity: 1;
  }
  > div {
    width: 100%;
    max-width: 300px;
    float: left;
    color: ${props => props.color || "#000"};
    letter-spacing: 1px;
    span {
      display: inline-block;
      font-family: 'Helvetica Neue LT W01_35 Thin', sans-serif;
      font-size: .625em;
      padding: 0;
      margin: 0 0 5px;
      white-space: no-wrap;
      text-transform: uppercase;
    }
    p {
      color: #333;
      padding: 0;
      font-size: .75em;
      margin: 0 0 4px;
    }
    > button {
      position: absolute;
      right: -5px;
      top: 10px;
      display: block;
      font-size: 1em;
      span {
        line-height: 1.4;
        vertical-align: top;
      }
      i {
        margin: 0;
        width: 10px;
        height: 10px;
        float: right;
        svg {
          stroke: #000;
          stroke-width: 2;
        }
      }
    }
    @media (min-width: 400px) {
      > button {
        display: none;
      }
    }
  }
`;

export default function Tooltip (props) {
  return (
    <StyledTooltip id="tooltip">
      <div>
        <span></span>
        <p></p>
        <Button icon="close" label="close" transparent onClick={() => toggleTooltip()}/>
      </div>
    </StyledTooltip>
  )
}
